import PT from 'prop-types';
import React, { Component } from "react";
import { Link } from "react-router"
import classNames from "classnames"
import { injectIntl, FormattedMessage } from "react-intl"
import { upperFirst, camelCase } from "lodash/string"
import Icon from "./Icon"
import sharedMessages from "../../messages"
import Image from './Image'
import { getStyles, getStyleTag, hexToRgbA } from '../../styles/dynamicStyles';

const DEFAULT_WIDTH = 440
const DEFAULT_HEIGHT = 300
const MAX_SHOW = 7

class ResultMedia extends Component {
  static propTypes = {
    linkTo: PT.string.isRequired,
    title: PT.string.isRequired,
    images: PT.arrayOf(
      PT.shape({
        src: PT.string.isRequired,
        aspect: PT.number.isRequired,
        title: PT.string.isRequired
      })
    ).isRequired,
    placeholder: PT.shape({
      small: PT.string.isRequired,
      retina: PT.string.isRequired
    }).isRequired,
    resultType: PT.string.isRequired,
    total: PT.number,
    coverImage: PT.object,
    icon: PT.string,
    iconColor: PT.string
  }

  render() {
    const {
      linkTo,
      title,
      images,
      placeholder,
      resultType,
      total: totalProp,
      intl,
      coverImage,
      icon,
      iconColor
    } = this.props
    const count = images.length > 0
    const haveImages = count > 0
    const imageAspect =
      haveImages && images.length > 0 && "aspect" in images[0]
        ? images[0].aspect
        : (DEFAULT_HEIGHT / DEFAULT_WIDTH) * 100
    const total = totalProp || count
    const showMore = MAX_SHOW < total
    const show = showMore ? MAX_SHOW - 1 : MAX_SHOW

    const typeMessageKey = `type${upperFirst(camelCase(resultType))}`
    const typeMessage =
      typeMessageKey in sharedMessages
        ? intl.formatMessage(sharedMessages[typeMessageKey])
        : upperFirst(resultType)

    const palceholderImageUrl = coverImage && coverImage.images && coverImage.images.small
      ? coverImage.images.small.url
      : placeholder && placeholder.small

    const triangleBgColor = {
      "--triangle-bg-color": hexToRgbA(iconColor, 0.8),
    }

    return (
      <div className="c-article__media-wrap">
        {getStyleTag(['c-article__media-object', 'c-article__media-layout-holder'])}
        <Link to={linkTo} className="c-article__media" style={getStyles('c-article__media')}>
          <div className="c-article__media-flag"
            style={{ ...getStyles('c-article__media-flag'), ...(iconColor && triangleBgColor) }}
            title={typeMessage}>
            <Icon icon={icon || "article-type"} color={iconColor} title={typeMessage} />
          </div>
          <div
            className={classNames("c-article__media-cont", {
              "c-article__media-cont--multi": images.length > 1
            })}
          >
            <div
              className={classNames("c-article__media-layout-holder", {
                "c-article__media-layout-holder--noaspect": imageAspect === 0
              })}
              style={{ paddingBottom: imageAspect + "%" }}
            >
              &nbsp;{/* annoyingly, this is the only way to have the div hold the shape of the incoming image, responsively friendly*/}
            </div>
            {!haveImages &&
              palceholderImageUrl && (
                <Image
                  className="c-article__media-object c-article__media-cover"
                  src={palceholderImageUrl}
                  alt={title}
                  title={title}
                />
              )}
            {haveImages && (
              <Image
                className="c-article__media-object c-article__media-cover"
                src={images[0].src}
                alt={images[0].title}
                title={images[0].title}
              />
            )}
            {haveImages &&
              images.length > 1 && (
                <div className="c-article__media-extra-images">
                  {haveImages &&
                    images
                      .slice(1, show)
                      .map((img, i) => (
                        <Image
                          className="c-article__media-object"
                          key={i}
                          src={img.src}
                          alt={img.title}
                          title={img.title}
                        />
                      ))}
                  {showMore && (
                    <span className="c-article__media-object c-article__media-object--more">
                      <strong>+{total - show}</strong>
                      <br />
                      <FormattedMessage {...sharedMessages.more} />
                    </span>
                  )}
                </div>
              )}
          </div>
        </Link >
      </div >
    )
  }
}

export default injectIntl(ResultMedia)



// WEBPACK FOOTER //
// ./webapp/components/elements/ResultMedia.js